// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_UPDATE_STATE = 'update/SET_UPDATE_STATE';
export const ADD_UPGRADE_RESULT = 'update/SET_UPGRADE_RESULT';
export const SET_FAILED_TASKS = 'update/SET_FAILED_TASKS';
export const RETRY_CR_UPGRADE = 'update/RETRY_CR_UPGRADE';
export const SET_UPGRADING_FLAG = 'update/SET_UPGRADING_FLAG';
